export class ProductGallery {
	constructor() {
		this.images = [];
		this.currentIndex = 0;
		this.lightbox = null;
		this.lightboxTrack = null;
		this.closeBtn = null;

		this.initMainImageUpdate();
		this.initLightbox();
	}

	/**
	 * Gestisce il cambio immagine principale con loader
	 */
	initMainImageUpdate() {
		window.updateMainImage = (variant) => {
			const imgWrapper = document.querySelector(".js-product-main-image");
			const imgEl = imgWrapper?.querySelector("img");
			const loader = imgWrapper?.parentElement.querySelector(
				".js-product-gallery-loader"
			);

			if (!imgEl) return;

			loader?.classList.remove("hidden");

			if (!imgEl.dataset.defaultSrc) {
				imgEl.dataset.defaultSrc = imgEl.src;
			}

			const newSrc =
				variant.featured_image?.src || imgEl.dataset.defaultSrc;

			const tempImg = new Image();
			tempImg.src = newSrc;

			tempImg.onload = () => {
				imgEl.addEventListener(
					"load",
					() => loader?.classList.add("hidden"),
					{ once: true }
				);
				imgEl.src = newSrc;
				imgEl.srcset = newSrc;
			};

			tempImg.onerror = () => {
				imgEl.src = imgEl.dataset.defaultSrc;
				imgEl.srcset = imgEl.dataset.defaultSrc;
				loader?.classList.add("hidden");
			};
		};
	}

	/**
	 * Inizializza click per aprire lightbox
	 */
	initLightbox() {
		// Prende solo le immagini della gallery
		this.images = [
			...document.querySelectorAll(".js-product-image-lightbox"),
		];

		this.images.forEach((img, index) => {
			img.addEventListener("click", () => this.openLightbox(index));
		});
	}

	openLightbox(index) {
		this.currentIndex = index;

		// Crea DOM del lightbox solo ora
		const lightboxHtml = `
			<div id="lightbox" class="fixed inset-0 bg-black/90 z-50 flex items-center justify-center overflow-hidden">
				<div id="lightbox-track" class="flex h-full transition-transform duration-300 ease-in-out"></div>
				<button id="lightbox-close" class="absolute top-4 right-4 text-white text-3xl z-50">✕</button>
			</div>
		`;
		document.body.insertAdjacentHTML("beforeend", lightboxHtml);

		this.lightbox = document.getElementById("lightbox");
		this.lightboxTrack = document.getElementById("lightbox-track");
		this.closeBtn = document.getElementById("lightbox-close");

		this.renderSlides();
		this.updateTransform();

		document.body.style.overflow = "hidden";

		// Chiudi lightbox
		this.lightbox.addEventListener("click", (e) => {
			if (e.target === this.lightbox) this.closeLightbox();
		});
		this.closeBtn.addEventListener("click", () => this.closeLightbox());

		this.initSwipe();
	}

	closeLightbox() {
		if (this.lightbox) {
			this.lightbox.remove();
			this.lightbox = null;
			this.lightboxTrack = null;
			this.closeBtn = null;
		}
		document.body.style.overflow = "";
	}

	renderSlides() {
		this.lightboxTrack.innerHTML = this.images
			.map(
				(img) => `
				<div class="flex-shrink-0 w-full h-full flex items-center justify-center pointer-events-none">
					<img src="${img.src}" class="max-w-[90%] max-h-[90%] object-contain pointer-events-auto select-none" draggable="false" />
				</div>
			`
			)
			.join("");
	}

	updateTransform() {
		this.lightboxTrack.style.transform = `translateX(-${
			this.currentIndex * window.innerWidth
		}px)`;
	}

	initSwipe() {
		let startX = 0;
		let currentX = 0;
		let isDragging = false;

		const startDrag = (e) => {
			isDragging = true;
			startX = e.touches ? e.touches[0].clientX : e.clientX;
			this.lightboxTrack.classList.remove("transition-transform");

			// Evita drag nativo immagini
			if (e.target.tagName === "IMG") e.preventDefault();
		};

		const onDrag = (e) => {
			if (!isDragging) return;
			currentX = (e.touches ? e.touches[0].clientX : e.clientX) - startX;
			this.lightboxTrack.style.transform = `translateX(${
				currentX - window.innerWidth * this.currentIndex
			}px)`;
		};

		const endDrag = () => {
			if (!isDragging) return;
			isDragging = false;
			this.lightboxTrack.classList.add("transition-transform");

			if (currentX > 50 && this.currentIndex > 0) this.currentIndex--;
			if (currentX < -50 && this.currentIndex < this.images.length - 1)
				this.currentIndex++;

			this.updateTransform();
			currentX = 0;
		};

		this.lightbox.addEventListener("touchstart", startDrag, {
			passive: false,
		});
		this.lightbox.addEventListener("mousedown", startDrag);
		window.addEventListener("touchmove", onDrag, { passive: false });
		window.addEventListener("mousemove", onDrag);
		window.addEventListener("touchend", endDrag);
		window.addEventListener("mouseup", endDrag);
	}
}
